import { get, post, put } from "./api";
import { MarketReport, MarketReportParams } from "../types/MarketReport";

export const getMarketReports = (): Promise<{
  marketReports: MarketReport[];
}> => {
  return get("/marketReports");
};

export const getAllMarketReports = (): Promise<{
  marketReports: MarketReport[];
}> => {
  return get("/marketReports/admin");
};

export const getMarketReportSignedUrl = (
  fileName: string,
  fileType: string
) => {
  return post("/marketReports/admin/signedUrl", { fileName, fileType });
};

export const putMarketReportPdf = (url: string, data: any) => {
  return put(url, data, { "Content-Type": "application/pdf" });
};

export const createMarketReport = (report: MarketReportParams) => {
  return post("/marketReports/admin/create", report);
};

export const updateMarketReport = (
  id: number,
  report: MarketReportParams
) => {
  return post("/marketReports/admin/update", { id, ...report });
};

export const deleteMarketReport = (id: number) => {
  return post("/marketReports/admin/delete", { id });
};
